export const DPR = window.devicePixelRatio;

export const SAFE_DPR = Math.max(2, DPR);

export function getDPR() {
  const DPR = window.devicePixelRatio;
  return DPR;
}

export enum EventTypes {
  down = 'down',
  move = 'move',
  up = 'up',
}

export enum TYPES {
  text = 'text',
  image = 'image',
  line = 'line',
  shape = 'shape',
  path = 'path',
  col = 'col',
  row = 'row',
  group = 'group',
  frame = 'frame',
  video = 'video',
  chart = 'chart',
}

export enum MASK_TYPES {
  alpha = 'alpha',
  luminance = 'luminance',
}

export enum MASK_MODE_TYPES {
  clip = 'clip',
  intersect = 'intersect',
}

export enum TEXT_FILL_MODE {
  none = '',
  char = 'char',
  line = 'line',
}

export enum FRAME_LAYOUT_MODES {
  horizontal = 'horizontal',
  vertical = 'vertical',
}

export enum TEXT_VERTICAL_ALIGN_TYPES {
  top = 'top',
  center = 'center',
  bottom = 'bottom',
}

export enum TEXT_HORIZONTAL_ALIGN_TYPES {
  left = 'left',
  center = 'center',
  right = 'right',
  justify = 'justify',
}

export enum TEXT_DECORATION_TYPES {
  underline = 'underline',
  lineThrough = 'line-through',
}

export enum FILL_TYPES {
  NONE = 'none',
  GRADIENT = 'gradient',
  GRADIENT_PATTERN = 'gradient-pattern',
  DYNAMIC = 'dynamic',
  IMAGE = 'image',
  COLOR = 'color',
  PATTERN = 'pattern',
}

export enum SHAPES {
  rect = 'rect',
  ellipse = 'ellipse',
  triangle = 'triangle',
  star = 'star',
  polygon = 'polygon',
  hexagon = 'hexagon',
  octagon = 'octagon',
  pentagon = 'pentagon',
  cross = 'cross',
  heart = 'heart',
}

export enum LayoutItemTypes {
  start = 'start',
  center = 'center',
  end = 'end',
}

export enum LayoutSizeType {
  hug = 'Hug',
  fill = 'Fill',
  fixed = 'Fixed',
}

export enum LayoutDirections {
  top = 'top',
  bottom = 'bottom',
  center = 'center',
  left = 'left',
  right = 'right',
}

export enum ImageObjectFitTypes {
  cover = 'cover',
  contain = 'contain',
  fill = 'fill',
  scaleDown = 'scale-down',
  none = 'none',
}

export enum LAYER_ORDER_TYPES {
  bringToFront = 'bringToFront',
  forward = 'forward',
  bringToBack = 'bringToBack',
  backward = 'backward',
}

export const IMAGE_FILTERS = [
  {
    key: 'Binarize',
    params: [
      {
        key: 'threshold',
        type: 'number',
      },
    ],
  },
  {
    key: 'Brightness',
    params: [
      {
        key: 'brightness',
        type: 'number',
      },
    ],
  },
  {
    key: 'Gamma',
    params: [
      {
        key: 'gamma',
        type: 'number',
      },
    ],
  },
  {
    key: 'Sharpen',
    params: [
      {
        key: 'factor',
        type: 'number',
      },
    ],
  },
  {
    key: 'Solarize',
    params: [],
  },
  {
    key: 'GaussianBlur',
    params: [
      {
        key: 'brightness',
        type: 'number',
      },
    ],
  },
  {
    key: 'GrayScale',
    params: [],
  },
];
